import { post, get } from '@/utils/http/http'
import {
  MARKET_URL,
  SUBSCRIBE_URI,
  FIXUP_URL,
  LIVE_MEETING_URL
} from '@/utils/http/baseUrl'

// 获取活动
export const getActivityAsync = params =>
  post(`${MARKET_URL}/api/v1/ticketing/getactivityasync`, params, false)

// 订阅推送
export const subscribeMsg = params =>
  post(`${SUBSCRIBE_URI}/pushservice/msgPush/SubscribeMsg`, params, false)

// 获取订阅配置
export const GetSubscribeConfig = params =>
  get(`${SUBSCRIBE_URI}/pushservice/msgPush/GetSubscribeConfig`, params, false)

// 检测是否已订阅(旧)
export const checkIsSubscribe = params =>
  get(`${FIXUP_URL}/api/v1/SubscribePush/CheckIsSubscribe`, params, false)
// 检测是否已订阅(新)
export const checkIsSubscribeV2 = params =>
  post(`${SUBSCRIBE_URI}/pushservice/msgPush/CheckIsSubscribe`, params, false)

// 获取参与用户
export const getjoinuserlist = params =>
  get(`${MARKET_URL}/api/v1/ticketing/getjoinuserlist`, params, false)

// 获取邀请榜
export const getinvitationlist = params =>
  get(`${MARKET_URL}/api/v1/ticketing/getinvitationlist`, params, false)
// 获取购票列表
export const getticketasync = params =>
  post(`${MARKET_URL}/api/v1/ticketing/getticketasync`, params, false)

// 检测购票先决条件
export const islimitpurchase = params =>
  get(`${MARKET_URL}/api/v1/ticketing/islimitpurchase`, params, false)

// 获取表单
export const getactticketandformlist = params =>
  post(`${MARKET_URL}/api/v1/ticketing/getactticketandformlist`, params, false)

// 获取领票表单
export const getactform = params =>
  get(`${MARKET_URL}/api/v1/ticketing/getactform`, params, false)

// 获取我的票券
export const getmyactticketlist = params =>
  post(`${MARKET_URL}/api/v1/ticketing/getmyactticketlist`, params, false)

// 获取分享票券列表
export const getshareticlist = params =>
  post(`${MARKET_URL}/api/v1/ticketing/getshareticlist`, params, false)

// 获取待签到列表
export const getnotsigninlist = params =>
  post(`${MARKET_URL}/api/v1/ticketing/getnotsigninlist`, params, false)

// 提交报名
export const saveuseractsignup = params =>
  post(`${MARKET_URL}/api/v1/ticketing/saveuseractsignup`, params, false)

// 替换报名
export const replaceuseractsignup = params =>
  post(`${MARKET_URL}/api/v1/ticketing/replaceuseractsignup`, params, false)

// 取消付款订单
export const cancelpaymentuseractsignup = params =>
  post(
    `${MARKET_URL}/api/v1/ticketing/cancelpaymentuseractsignup`,
    params,
    false
  )

// 重新付款
export const paymentuseractsignup = params =>
  post(`${MARKET_URL}/api/v1/ticketing/paymentuseractsignup`, params, false)

// 修改分享状态
export const updateactticsharestatus = params =>
  post(`${MARKET_URL}/api/v1/ticketing/updateactticsharestatus`, params, false)

// 获取用户信息
export const UserInfo = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingSignUpService/UserInfo?enc_id=${params}`,
    null,
    false
  )

// 获取我的活动
export const GetActivity = params =>
  post(`${MARKET_URL}/api/v1/ticketing/getmyactlistasync`, params, false)

// 获取峰会展会列表
export const GetMyActivityList = params =>
  get(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/GetMyActivityList`,
    params,
    false
  )

// 获取短信通知和加群
export const getactgroupandnoticeasync = params =>
  get(`${MARKET_URL}/api/v1/ticketing/getactgroupandnoticeasync`, params, false)

// 检测是否有未支付票券
export const inspectuserpaymentasync = params =>
  post(`${MARKET_URL}/api/v1/ticketing/inspectuserpaymentasync`, params, false)

// 获取验证码
export const GetTpFormValidCode = params =>
  post(`/livehome/GetTpFormValidCode`, params, false)

// 修改签到状态
export const saveactsigninstatus = params =>
  post(`${MARKET_URL}/api/v1/ticketing/saveactsigninstatus`, params, false)

// 获取自定义邀请卡
export const get_sharecard_list = params =>
  get(`${MARKET_URL}/api/v1/public/sharecard/get_sharecard_list`, params, false)

// 添加浏览记录和邀请记录
export const setbrowseandinvitation = params =>
  post(`${MARKET_URL}/api/v1/ticketing/setbrowseandinvitation`, params, false)

// 获取分享信息
export const GetMeetingActivityShareCache = params =>
  get(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/GetMeetingActivityShareCache`,
    params,
    false
  )

// 通过券码查询优惠券
export const getActCouponCodeAsync = params =>
  post(`${MARKET_URL}/api/v1/ticketing/getactcouponcodeasync`, params, false)
